// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"125":"92af8db2","316":"b2331228"}[chunkId] + ".js";
};